import React from "react";
import { ExecutionJob } from "../../../types/ExecutionJob/ExecutionJob.ts";
import { Card, Divider, Stack, Typography } from "@mui/material";
import { CheckRounded, CloseRounded } from "@mui/icons-material";
import { translate } from "../../../services/Translations/translatorService";

type CompletedExecutionJobProps = {
  executionJob: ExecutionJob;
};

export default function CompletedExecutionJob({ executionJob }: CompletedExecutionJobProps) {
  return (
    <Card elevation={1}>
      {executionJob.steps.map((step, index) => (
        <>
          <Stack direction={"row"} spacing={2} sx={{ margin: "1rem", alignItems: "center" }}>
            {step.status === "skipped" && <CloseRounded sx={{ color: "action.disabled" }} />}
            {step.status === "failed" && <CloseRounded sx={{ color: "error.main" }} />}
            {step.status === "completed" && <CheckRounded sx={{ color: "success.main" }} />}
            <Typography>
              <strong>{translate("executionJob.step.actionType.values." + step.actionType)}</strong>
            </Typography>
          </Stack>
          {index < executionJob.steps.length - 1 && <Divider />}
        </>
      ))}
    </Card>
  );
}
